export class RecommendationAnswerInput{
    recommendationBookId: number
    userId: number
    answerText: string
    positiveNegative: boolean = true
}